let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eoyr9")).then(() => parcelRequire('7So8Q'));